'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleContentStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  theme: _propTypes2.default.object
};
/** Prop Receivers */

var base = function base(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.sidebar.toggleButton.content,
      paddingY = _theme$reactackle$com.paddingY,
      paddingX = _theme$reactackle$com.paddingX;
  return '\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n  ';
};
/** Styles */


var ToggleContentStyled = exports.ToggleContentStyled = _styledComponents2.default.div.withConfig({
  displayName: 'ToggleContentStyled'
})(['flex-grow:1;display:flex;align-items:center;', ' ', ';'], base, (0, _reactackleCore.transition)('opacity'));

ToggleContentStyled.propTypes = propTypes;
ToggleContentStyled.displayName = 'ToggleContentStyled';